import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { connect } from 'react-redux'
import { formValueSelector, reduxForm } from 'redux-form'
import { FORM_PESO_BRUTO } from '../../../../config/forms'
import { COLORES } from '../../../../config/colores'
import { Button, Dialog } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import MotivosActividadBarreraBruto from '../../../Forms/SharedComponents/containers/MotivosActividadBarreraBruto'
import { guardarMotivoActividadBarrera } from '../../actions'

function BarreraBruto (props) {
  const { setMotivo } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    props.dialogOpen && props.dialogOpen(true)
    setOpen(true)
    setMotivo(null)
  }
  const handleClose = () => {
    setOpen(false)
    props.dialogOpen && props.dialogOpen(false)
  }

  const handleSubmit = () => {
    const { motivo } = props
    if (motivo) {
      props.guardarMotivoActividadBarrera()
      handleClose()
    } else {
      toast.error('Debe seleccionar un motivo')
    }
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='md'
      >
        <DialogView
          cancelCallback={handleClose}
          confirmCallback={handleSubmit}
          title='Motivos actividad barrera'
          content={<div style={{ padding: '8px' }}>
            <h5 style={{ marginBottom: '2%' }}>
                                    Para poder abrir la barrera de salida, debe seleccionar un motivo
            </h5>
            <div style={{ padding: '8px 0' }}>
              <MotivosActividadBarreraBruto
                setMotivo={setMotivo}
              />
            </div>
          </div>
          }
        />
      </Dialog>

      <Button
        variant='contained'
        style={{ backgroundColor: COLORES.grey.dark, color: '#ffffff', width: '100%' }}
        onClick={handleOpen}
      >
              Abrir barrera salida
      </Button>

    </>
  )
}

const selector = formValueSelector(FORM_PESO_BRUTO)

const mapStateToProps = (state) => {
  return {
    motivo: selector(state, 'motivoActBarrera')
  }
}

const mapActionsToProps = {
  guardarMotivoActividadBarrera
}

const withRedux = connect(mapStateToProps, mapActionsToProps)

const withReduxForm = reduxForm({
  form: FORM_PESO_BRUTO,
  destroyOnUnmount: false,
  keepDirtyOnReinitialize: false
})

export default withRedux(withReduxForm(BarreraBruto))
